import {
  ModuleRegistry,
  AllCommunityModule,
  provideGlobalGridOptions,
} from 'ag-grid-community';

import { createCutrApp } from '@/setup';
import { routes } from '@/modules/routing.js';
import ModalManager from '@/helpers/modal-manager';
import App from './App.vue';
// Imported last so the global styles come after every component's in the bundle.
import '@/setup/styles';

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({
  theme: 'legacy',
});

const { app, mount } = createCutrApp({ rootComponent: App, routes });

app.use(ModalManager);

mount('#app');
